import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

interface useUrlStateManagerProps{
  
}

export const useUrlStateManager = <T extends Record<string, any>>(
  defaultState: T,
  config?: {
    isEqual?: (a: T, b: T) => boolean
    persistKeys?: (keyof T)[];
    serializers?: {
      [K in keyof T]?: (value: T[K]) => string | undefined
    }
    deserializers?: {
      [K in keyof T]?: (value: string) => T[K];
    }
  }
) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const state = useMemo(() => {
    const params = Object.fromEntries(searchParams.entries())
    const result = { ...defaultState }

    Object.keys(defaultState).forEach((key) => {
      const paramKey = key as keyof T
      const paramValue = params[key as string]
      
      if (paramValue) {
        if (config?.deserializers?.[paramKey]) {
          result[paramKey] = config.deserializers[paramKey]!(paramValue);
        } else {
          try {
            result[paramKey] = JSON.parse(paramValue)
          } catch {
            result[paramKey] = paramValue as any
          }
        }
      }
    })

    return result;
  }, [
   searchParams, 
   defaultState, 
   // config
  ]);


  const checkIsEqual = (newState: any) => {
    const isEqual = true

    //const params = Object.fromEntries(searchParams.entries())
    Object
      .keys(state)
      .forEach((key) => {
        const paramKey = key as keyof T
        const paramValue = state[key as string]
    })

    //const newStateEntries =  Object.entries(state)

    return isEqual
  }


  const setState = (updater: Partial<T> | ((prev: T) => Partial<T>)) => {
    const newState = typeof updater === 'function' 
      ? updater(state) 
      : updater

    // const isEqual = checkIsEqual(newState)
    // if (isEqual === true){
    //   return
    // }

    const params = new URLSearchParams(searchParams)
    Object.entries(newState).forEach(([key, value]) => {
        const shouldPersist = !config?.persistKeys || config.persistKeys.includes(key);   

        if (shouldPersist) {
            if (value !== undefined && value !== null && value !== '') {
                const serializer = config?.serializers?.[key]
                const stringValue = serializer 
                ? serializer(value) 
                : JSON.stringify(value)

                if (stringValue === undefined){
                    params.delete(key)
                    return
                }

                params.set(key, stringValue)
            } else {
                params.delete(key)
            }
        }
    })

    setSearchParams(params, { replace: true });
  }

  const reset = () => {
    setSearchParams(new URLSearchParams(), { replace: true });
  }

  return [
    state, 
    setState, 
    reset
  ] as const
}